import { createClient } from '@supabase/supabase-js';
import { envConfig } from 'config/env';

const { supabaseUrl, supabaseAnonKey } = envConfig.provider;
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
  },
});
